// Why a position matters (shared copy for the portfolio, settings and Orca's
// answers) — from the dictionary, in the current language.
import i18n from '@/i18n';

export const positionWhyShort = () => i18n.t('portfolio:why.short');
export const positionWhy = () => i18n.t('portfolio:why.long');
export const positionNudge = () => i18n.t('portfolio:why.nudge');
